import * as yup from 'yup';

export const getFeedbackFormValidation = () =>
  yup.object().shape({
    email: yup.string().trim().email('Not valid email').required('Email is required field'),
    subject: yup.string().trim().required('Subject is required field'),
    message: yup.string().trim().required('Message is required field'),
  });
